export default __webpack_public_path__ + "fonts/Aeonik-Regular_ba7975c544e1ac9dab96e8913c5588b8.woff";